import { Pipe, PipeTransform } from '@angular/core';
import { SizePrice, OrderableItemService } from 'ngx-web-api';

@Pipe({
  name: 'servings',
})
export class ServingsPipe implements PipeTransform {
  constructor(private orderableItemService: OrderableItemService) {}

  transform(sizePrice: SizePrice): string {
    if (!!sizePrice) {
      return this.orderableItemService.getServings(sizePrice);
    }
    return null;
  }
}
